<template>
  <div
  
      @mouseover="hoverMethod(finishPosition.raceId,finishPosition.position)"
      @mouseleave="leave(finishPosition.raceId)"

    :id="positionId"
    v-on:click="
      requestFormGridData(finishPosition.raceId, finishPosition.position)
    "
    v-bind:style="styleObject"
    class="previous-race-finish text clickable-block"
    :class="[showBorder ?  'black-border' : '' , finishPosition.raceId ]"
  >
    <span
    ref="testref"
    style=" margin: 0.15rem 0.4rem;"
   
    >
      {{ finishPosition.raceCourseCode }}&nbsp;{{ finishPosition.position }}
    </span>
  </div>
</template>

<script>
    import {finishingPositions} from "./configuration/finishingPositionColors.constant";
    import {FormGridService} from '../services/formGrid.service';
     import {mapState, mapMutations} from 'vuex';

    export default {
        name: 'PreviousFinishPosition',
        data: function () {
            return {
                showBorder: false,
                finishingPositions: finishingPositions,
               id:"",
                styleObject: {
                    backgroundColor: ''
                }
            };
        },
        props: {
            finishPosition: Object,
            onClickCallback: Function,
            onHover: Function,
            onHoverOut: Function,
            positionId: String
        },
        computed: mapState(['selectedFormGrid']),
        methods: {
            leave(raceID){
                  
              var T  = document.getElementsByClassName(raceID);
              for(var item of T){

                item.classList.remove('flash')

              }
                      
            },

            hoverMethod(id){
       
              var T  = document.getElementsByClassName(id);
              for(var item of T){

                item.classList.add('flash')

              }
                
            },
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            requestFormGridData(id, separateRaceHorsePosition) {
                this.onClickCallback(separateRaceHorsePosition);
                FormGridService.getFormGrid(id, () => {this.myMethod()});
               
            },
            setBackgroundColors(finishPosition = this.finishPosition) {
                this.styleObject.backgroundColor = finishPosition.position <= 5 ? `${this.finishingPositions[finishPosition.position - 1]}` : '#FFFFFF';
                this.showBorder = finishPosition.position > 5;
            }
        },
        watch: {
            finishPosition: function (newVal, oldVal) {
                this.setBackgroundColors(newVal);
            }
        },
        mounted: function () {
          
            document.querySelector(`#${this.positionId}`).addEventListener("mouseenter", () => {
                this.onHover(this.finishPosition.raceId);
            });

            document.querySelector(`#${this.positionId}`).addEventListener("mouseleave", () => {
                this.onHoverOut();
            });

            this.$nextTick(this.setBackgroundColors.bind(this));
  
            }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flash>span{
  animation: blinker 1s step-start infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
  } 

.black-border {
  border: solid 1px #000000 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}

.previous-race-finish {
  background-color: #6e0f80;
  margin-right: 0.15rem;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  width: 40px;
}

.previous-race-finish-text {
  margin: 0.15rem 0.4rem;
}
</style>
